import React from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import AboutUs from "./components/AboutUs";
import WhyUs from "./components/WhyUs";
import Services from "./components/Services";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Navbar />
      <Home/>
      <AboutUs />
       <WhyUs/>
      <Services />
      <ContactForm/>
      <Footer />
    </>
  );
}

export default App;
